export default __webpack_public_path__ + "static/media/benefit-3.7b90e3d2.png";